import React from "react";
import { PlayheadHandle } from "../Playhead";
import "./Ruler.scss";

function Ruler({ totalWidth, rulerTicks, playheadX, onPointerDown, onPlayheadDrag }) {
  return (
    <div className="it-ruler" style={{ minWidth: totalWidth }} onPointerDown={onPointerDown}>
      {rulerTicks.map(({ x, isMajor, label }) => (
        <div
          key={x}
          className={`it-ruler-tick ${isMajor ? "it-ruler-tick--major" : "it-ruler-tick--minor"}`}
          style={{ left: x }}
        >
          {label && <span className="it-ruler-label">{label}</span>}
        </div>
      ))}

      <PlayheadHandle x={playheadX} onPointerDown={onPlayheadDrag} />
    </div>
  );
}

export default Ruler;
